// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stroke[data-v-bb593f30] {\n  stroke: currentColor;\n  stroke-width: 8px;\n  stroke-linecap: round;\n}\n.stroke-bold[data-v-bb593f30] {\n  stroke: currentColor;\n  stroke-width: 16px;\n  stroke-linecap: round;\n}\n.wave[data-v-bb593f30] {\n  stroke: currentColor;\n  fill: transparent;\n  stroke-width: 12px;\n  stroke-linecap: round;\n}\n.cls-1-inv[data-v-bb593f30] {\n  fill: transparent;\n  stroke-linejoin: round;\n  stroke-width: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
